<template>
  <div class="col-12 gear-preview">
    <div class="row icon-row mb-25">
      <div class="offset-45 p-0 pl-1 placeholder col-3" :class="{'head' : equipment.head.id === 0}">
        <ItemSlot :id="equipment.head.id" :itemSlot="'head'"
                  @update="(item) => {this.$emit('update','head',item);}"></ItemSlot>
      </div>

      <div class="col-4">
        <button class="btn btn-osrs reset-container mx-0 float-right" v-b-tooltip.hover.bottom
                title="Reset Equipment">
          <b-icon-arrow-counterclockwise @click="resetGear"></b-icon-arrow-counterclockwise>
        </button>
        <!--        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Reset" alt="Reset" @click="resetGear">-->
      </div>
    </div>

    <div class="row icon-row mb-25">
      <div class="offset-15 p-0 placeholder col-3" :class="{'cape' : equipment.cape.id === 0}">
        <ItemSlot :id="equipment.cape.id" :itemSlot="'cape'"
                  @update="(item) => {this.$emit('update','cape',item);}"></ItemSlot>
      </div>
      <div class="p-0 pl-1 placeholder col-3" :class="{'neck' : equipment.neck.id === 0}">
        <ItemSlot :id="equipment.neck.id" :itemSlot="'neck'"
                  @update="(item) => {this.$emit('update','neck',item);}"></ItemSlot>
      </div>
      <div class="p-0 pl-1 placeholder col-3" :class="{'ammo' : equipment.ammo.id === 0}">
        <ItemSlot :id="equipment.ammo.id" :itemSlot="'ammo'"
                  @update="(item) => {this.$emit('update','ammo',item);}"></ItemSlot>
      </div>
    </div>

    <div class="row icon-row mb-25">
      <div class="offset-15 p-0 pl-1 placeholder col-3" :class="{'weapon' : equipment.weapon.id === 0}">
        <ItemSlot :id="equipment.weapon.id" :itemSlot="'weapon'"
                  @update="(item) => {this.$emit('update','weapon',item);}"></ItemSlot>
      </div>
      <div class="p-0 pl-1 placeholder col-3" :class="{'body' : equipment.body.id === 0}">
        <ItemSlot :id="equipment.body.id" :itemSlot="'body'"
                  @update="(item) => {this.$emit('update','body',item);}"></ItemSlot>
      </div>
      <div class="p-0 placeholder col-3" :class="{'shield' : equipment.shield.id === 0}">
        <ItemSlot :id="equipment.shield.id" :itemSlot="'shield'"
                  @update="(item) => {this.$emit('update','shield',item);}"></ItemSlot>
      </div>
    </div>

    <div class="row icon-row mb-25  pl-1">

      <div v-show="blowpipeEquipped" class="offset-15 p-0 pl-1 placeholder col-3 blowpipe-ammo"
           :class="{'blowpipe_ammo' : equipment.blowpipe_ammo.id === 0}">
        <ItemSlot :id="equipment.blowpipe_ammo.id" :itemSlot="'weapon'" :is-blowpipe="true"
                  @update="(item) => {this.$emit('update','blowpipe_ammo',item);}"></ItemSlot>
      </div>

      <div class="p-0 placeholder col-3"
           :class="{'legs' : equipment.legs.id === 0, 'pl-1': this.blowpipeEquipped, 'offset-45': !this.blowpipeEquipped}">
        <ItemSlot :id="equipment.legs.id" :itemSlot="'legs'"
                  @update="(item) => {this.$emit('update','legs',item);}"></ItemSlot>
      </div>
    </div>

    <div class="row icon-row">
      <div class="offset-15 p-0 pl-1 placeholder col-3" :class="{'hands' : equipment.hands.id === 0}">
        <ItemSlot :id="equipment.hands.id" :itemSlot="'hands'"
                  @update="(item) => {this.$emit('update','hands',item);}"></ItemSlot>
      </div>
      <div class="p-0 pl-1 placeholder col-3" :class="{'feet' : equipment.feet.id === 0}">
        <ItemSlot :id="equipment.feet.id" :itemSlot="'feet'"
                  @update="(item) => {this.$emit('update','feet',item);}"></ItemSlot>
      </div>
      <div class="p-0 placeholder col-3" :class="{'ring' : equipment.ring.id === 0}">
        <ItemSlot :id="equipment.ring.id" :itemSlot="'ring'"
                  @update="(item) => {this.$emit('update','ring',item);}"></ItemSlot>
      </div>
    </div>
  </div>
</template>

<script>
  import ItemSlot from "./ItemSlot";
  import EquipmentCost from "./EquipmentCost";
  import {BIconArrowCounterclockwise} from 'bootstrap-vue'

  export default {
    name: "GearPreview",
    components: {EquipmentCost, ItemSlot, BIconArrowCounterclockwise},
    props: {
      equipment: {
        type: Object,
        default: function () {
          return {
            head: {id: 0},
            cape: {id: 0},
            neck: {id: 0},
            ammo: {id: 0},
            weapon: {id: 0},
            body: {id: 0},
            shield: {id: 0},
            legs: {id: 0},
            hands: {id: 0},
            feet: {id: 0},
            ring: {id: 0},
            blowpipe_ammo: {id: 0},
          }
        }
      }
    },
    data() {
      return {
        colSize: 'col-3',
      }
    },
    computed: {
      blowpipeEquipped: function () {
        let blowpipeIds = [12924, 12926];
        return blowpipeIds.includes(this.equipment.weapon.id);
      }
    },
    methods: {
      resetGear: function () {
        for (const key of Object.keys(this.equipment)) {
          let none = require('@/assets/data/equipment/none.json');
          none.slot = key;
          this.$emit('update', key, none)
        }
      }
    }
  }
</script>

<style scoped>

  .placeholder {
    background-image: url("/static/images/icons/placeholders/empty.png");
    cursor: pointer;

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .placeholder.head {
    background-image: url("/static/images/icons/placeholders/head.png");
  }

  .placeholder.cape {
    background-image: url("/static/images/icons/placeholders/cape.png");
  }

  .placeholder.neck {
    background-image: url("/static/images/icons/placeholders/neck.png");
  }

  .placeholder.ammo {
    background-image: url("/static/images/icons/placeholders/ammo.png");
  }

  .placeholder.weapon {
    background-image: url("/static/images/icons/placeholders/weapon.png");
  }

  .placeholder.body {
    background-image: url("/static/images/icons/placeholders/body.png");
  }

  .placeholder.shield {
    background-image: url("/static/images/icons/placeholders/shield.png");
  }

  .placeholder.legs {
    background-image: url("/static/images/icons/placeholders/legs.png");
  }

  .placeholder.hands {
    background-image: url("/static/images/icons/placeholders/hands.png");
  }

  .placeholder.feet {
    background-image: url("/static/images/icons/placeholders/feet.png");
  }

  .placeholder.ring {
    background-image: url("/static/images/icons/placeholders/ring.png");
  }

</style>



// WEBPACK FOOTER //
// src/components/gear-selector/GearPreview.vue